import { useTheme } from 'styled-components';
import {
  BodyLoader,
  TransactionContainer,
  AssetIcons,
  Status,
  AssetCode,
  Amount,
  AmountSecond,
} from './styles';

export const DashboardTransactionsLoader = () => {
  const { colors } = useTheme();

  return (
    <TransactionContainer>
      {[...Array(5)].map((item, i) => {
        return (
          <BodyLoader
            key={i}
            backgroundColor={colors.surface.interactiveDefault}
            foregroundColor={colors.surface.pressed}
          >
            <AssetIcons />
            <Status />
            <AssetCode />
            <Amount />
            <AmountSecond />
          </BodyLoader>
        );
      })}
    </TransactionContainer>
  );
};
